<template>
	<main class="wrapper">
		<div>
			<el-button 
				type="primary"
				@click="create"
			>新增</el-button>
		</div>

		<x-table
			:tableData="tableData"
			:tableHeaders="tableHeaders"
			:pageModel="pageModel"
			:fetchList="fetchList"
			:clickData="clickData"
			@clickRight="clickRight"
			:total="total"
		></x-table>

		<el-dialog
			title="账号编辑"
			:visible.sync="showCreate"
		>
			<el-form ref="form" label-width="100px">
				<x-form
					label="账号"
					prop="user"
					required
					placeholder="请输入账号"
					v-model="createModel.user_name"
				></x-form>
				<x-form
					label="密码"
					type="password"
					prop="user"
					required
					placeholder="请输入密码"
					v-model="createModel.password"
				></x-form>
				<x-form
					label="确认密码"
					type="password"
					prop="user"
					required
					placeholder="请再次输入密码"
					v-model="createModel.password_again"
				></x-form>
			</el-form>

			<div slot="footer">
				<el-button @click="showCreate = false">取消</el-button>
				<el-button type="primary" @click="confirm">确认</el-button>
			</div>
		</el-dialog>
	</main>
</template>


<script type="text/javascript">
import {
	accountList,
	createAccount
} from '@/api/user'
export default {
	data() {
		return {
			showCreate: false,
			tableData: [],
			tableHeaders: [{
				headerKey: 'user_name',
				headerName: '账号',
			}],
			pageModel: {
				page: 1,
				size: 10
			},
			total: 0,
			createModel: {
				user_name: '',
				password: '',
				password_again: ''
			},
			clickData: [{
				value: 'edit',
				label: '编辑'
			}]
		}

	},
	methods: {
		create() {
			this.showCreate = true

			this.createModel.password = ''
			this.createModel.password_again = ''
		},
		fetchList() {
			accountList(this.pageModel).then(res => {
				this.total = res.data.total
				this.tableData = res.data.data
			})
		},
		confirm() {
			const value = this.validatorForm(this.$refs.form)

			if (value) return

			if (this.createModel.password !== this.createModel.password_again) {
				this.$message.warning('请检查密码是否输入一致')
				return
			}


			createAccount(this.createModel).then(res => {
				this.$message.success('保存成功')
				this.showCreate = false
				this.fetchList()
			})
		},
		clickRight({row}) {
			this.createModel.user_name = row.user_name
			this.createModel.id = row.id
			this.create()
		}
	},
	mounted() {
		this.fetchList()
	}
}
</script>

<style lang="less">
	
</style>